import React from 'react';

export default function Footer(props) {
    return (
        <footer style={{
            borderTop: '1px solid #bdbdbd',
            paddingTop: '.5rem',
            marginTop: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '.8rem',
        }}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"
                width="75"
                height="14"
                viewBox="0 0 300 55.4"
                preserveAspectRatio="xMidYMid slice"
            >
                <desc>Norges teknisk-naturvitenskapelige universitet</desc>
                <g>
                    <rect ry="6.5" rx="6.5" stroke="#07529e" strokeLinejoin="round" fillOpacity="0" height="40.92979" width="40.94877" y="6.80645" x="6.80645" strokeWidth="13.5"/>
                    <circle r="11.20652" cy="27.14839" cx="27.19355" fill="#07529e"/>
                    <path d="m181.231,0.05381l0,17.34259l-2.3,0c-0.23399,-2.6847 -0.543,-6.0631 -2.91901,-10.05123c-2.76199,-4.68465 -6.52499,-4.91587 -10.207,-5.06914l-4.297,0l0,50.11477l8.28801,0l0,1.847l-25.17201,0l0,-1.847l8.28601,0l0,-50.11477l-3.52901,0c-4.453,0.07816 -7.82899,0.07816 -11.05099,5.21928c-2.535,4.06929 -2.763,7.29149 -2.91901,9.90109l-2.222,0l0,-17.34257l48.04201,0l0,-0.00001l0,-0.00001z"/>
                    <path d="m203.02699,0.05381l26.55301,38.60409l-0.07201,-36.76021l-7.98199,0l0,-1.8439l17.11099,0l0,1.8439l-6.59999,0l-0.078,53.03682l-1.226,0.3783l-35.61301,-51.80552l0.07799,48.88351l8.216,0l0,1.847l-17.733,0l0,-1.847l7.06401,0l0,-50.49311l-7.06401,0l0,-1.8439l17.34599,0l0,0.00001l0,0.00001l0,0.00001l0.00002,-0.00001z"/>
                    <path d="m268.436,0.05381l0,1.8439l-7.603,0l-0.07001,35.83829c0.07001,7.5948 0.23199,14.8141 14.50497,14.8141c14.42697,0 15.34903,-6.2944 15.57703,-13.1234l-0.07501,-37.52899l-7.74799,0l0,-1.8439l16.95499,0l0,1.8439l-6.672,0l-0.078,34.45689c-0.078,10.0542 -0.15399,18.6519 -20.03098,18.6519c-2.83502,0 -9.59702,-0.3062 -13.88904,-2.0781c-6.83197,-2.9129 -6.985,-8.9009 -7.063,-16.2644l-0.07799,-34.76629l-6.601,0l0,-1.8439l22.87102,0l0,0.00001l0,0l0,-0.00001z"/>
                    <path d="m92.6648,0.05381l26.5532,38.60409l-0.078,-36.76021l-7.979,0l0,-1.8439l17.11399,0l0,1.8439l-6.60099,0l-0.075,53.03682l-1.228,0.3783l-35.61,-51.80552l0.0719,48.88351l8.2102,0l0,1.847l-17.7238,0l0,-1.847l7.0601,0l0,-50.49311l-7.0601,0l0,-1.8439l17.3455,0l0,0.00001l0,0.00001l0,0.00001l0,-0.00001z"/>
                </g>
            </svg>
            <span style={{marginLeft: '.5em', marginRight: '.5em'}}>-</span>
            <a href="mailto:orakel@ntnu.no">orakel@ntnu.no</a>
        </footer>
    );
}



// WEBPACK FOOTER //
// ./src/components/Footer.js